import { ReportsTransferredBadge } from '@/components/candidate-job-slider-v1/components/common/TransferredBadge';
import { KImage, KText } from '@/ui-library/components';
import { Flex, Link } from '@chakra-ui/react';

interface ApplicantNameCellProps {
  atsApplication: {
    id?: number;
    contact?: { image_url?: string; first_name?: string; last_name?: string };
    is_transferred_in?: boolean;
    transferred_from?: {
      job_name?: string;
      transferred_by?: { name?: string };
    };
    is_transferred_out?: boolean;
    transferred_to?: {
      job_id?: number;
      application_id?: number;
      job_name?: string;
      transferred_by?: { name?: string };
    };
  };
  jobId: number | string;
}

export const ApplicantNameCell = ({
  atsApplication,
  jobId: _job_id,
}: ApplicantNameCellProps) => {
  const {
    contact = {},
    is_transferred_out,
    transferred_to,
    id,
    is_transferred_in,
    transferred_from,
  } = atsApplication || {};
  const { job_id, application_id } = transferred_to || {};
  const { image_url, first_name, last_name } = contact || {};
  const showTransferredInBadge = is_transferred_in && transferred_from;
  const showTransferredOutBadge = is_transferred_out && transferred_to;
  return (
    <>
      {first_name ? (
        <Flex alignItems="center" gap="6px" w="100%" minW="0">
          <Link
            href={
              is_transferred_out
                ? `/jobs/${job_id}?tab=candidates&appId=${application_id}`
                : `/jobs/${_job_id}?tab=candidates&appId=${id}`
            }
            target="_blank"
            display="flex"
            alignItems="center"
            gap="6px"
            minW="0"
            overflow="hidden"
          >
            <KImage
              name={`${first_name} ${last_name}`}
              src={image_url}
              backgroundStyles={{ minWidth: '20px', minHeight: '20px' }}
            />
            <KText
              maxW="100%"
              enableTooltip={true}
              isTruncated
              size="sm-regular"
              _hover={{
                textDecoration: 'underline',
                color: 'primary-500',
                cursor: 'pointer',
              }}
              textTransform="capitalize"
            >
              {`${first_name || ''} ${last_name || ''}`}
            </KText>
          </Link>
          {showTransferredInBadge && (
            <ReportsTransferredBadge
              type="from"
              jobName={transferred_from.job_name}
              transferredBy={transferred_from.transferred_by}
            />
          )}
          {showTransferredOutBadge && (
            <ReportsTransferredBadge
              type="to"
              jobName={transferred_to.job_name}
              transferredBy={transferred_to.transferred_by}
            />
          )}
        </Flex>
      ) : (
        '-'
      )}
    </>
  );
};
